import { render, staticRenderFns } from "./projectAdd.vue?vue&type=template&id=1c176767&scoped=true&"
import script from "./projectAdd.vue?vue&type=script&lang=js&"
export * from "./projectAdd.vue?vue&type=script&lang=js&"
import style0 from "./projectAdd.vue?vue&type=style&index=0&id=1c176767&scoped=true&lang=css&"
import style1 from "./projectAdd.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c176767",
  null
  
)

export default component.exports